module.exports = __webpack_public_path__ + "img/greenDownArrow.8cfbd74b.svg";